import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-text"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Guardando cambios...", -1)

import { ref, watch, computed } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import { ModificarTorneoDTO, Torneo } from "@/interfaces/Torneo";
import { modificarTorneo } from "@/services/TorneosService";
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";
import axios from "axios";
import { torneoType, TorneoType } from "@/Constant/TiposTorneo";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalModificarTorneo',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);
const isValid = ref(true);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const searchQuery = ref<string>("");
const formattedAddress = ref<string>("");
const selectedLocation = ref<{ lat: number; lng: number } | null>(null);
const errorMessage = ref<string>("");
const zoom = ref<number>(14);
const tileLayerUrl = ref<string>(
  "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
);

const isSearching = ref<boolean>(false);
// Función para buscar la dirección ingresada por el usuario
const searchLocation = async () => {
  isSearching.value = true;
  if (!searchQuery.value.trim()) return;

  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
    searchQuery.value
  )}&addressdetails=1`;

  try {
    const response = await axios.get(url);
    if (response.data.length > 0) {
      const firstResult = response.data[0];
      selectedLocation.value = {
        lat: parseFloat(firstResult.lat),
        lng: parseFloat(firstResult.lon),
      };
      lugarTorneo.value = firstResult.lat + ", " + firstResult.lon;
      formattedAddress.value = formatAddress(firstResult);
      errorMessage.value = "";
    } else {
      errorMessage.value =
        "No se encontró la dirección. Se guardará sin enlace a Google Maps.";
      selectedLocation.value = null;
      lugarTorneo.value = searchQuery.value;
      formattedAddress.value = searchQuery.value;
    }
  } catch (error) {
    console.error("Error buscando la dirección:", error);
    errorMessage.value = "Error al buscar la dirección.";
  } finally {
    isSearching.value = false;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatAddress = (data: any): string => {
  if (!data || !data.display_name) return "Dirección no disponible";

  const { name, address } = data;

  // Extraer componentes clave
  const road = address.road || name || "";
  const houseNumber = address.house_number ? `, ${address.house_number}` : "";
  const city = address.city || address.town || address.village || "";
  const state = address.state || "";
  const postcode = address.postcode || "";
  const country = address.country || "";

  // Construir dirección con formato legible
  return [`${road}${houseNumber}`, city, state, postcode, country]
    .filter(Boolean) // Elimina valores vacíos
    .join(", ");
};

const handleDateChangeInicio = (newDate: string | null) => {
  if (newDate) fechaInicioTorneo.value = convertirFecha(newDate);
};
const handleDateChangeFin = (newDate: string | null) => {
  if (newDate) fechaFinTorneo.value = convertirFecha(newDate);
};
const handleDateChangeInscripcion = (newDate: string | null) => {
  if (newDate) fechaFinInscripcion.value = convertirFecha(newDate);
};
const handleDateChangeListas = (newDate: string | null) => {
  if (newDate) fechaFinEntregaListas.value = convertirFecha(newDate);
};
const handleDateChangeInicioInscripcion = (newDate: string | null) => {
  if (newDate) fechaInicioInscripcion.value = convertirFecha(newDate);
};
const nombreTorneo = ref<string>();
const limiteParticipantes = ref<number>();
const descripcionTorneo = ref<string>();
const precioTorneo = ref<number>();
const numeroPartidas = ref<number>();
const puntosTorneo = ref<number>();
const estadoTorneo = ref<number>(1);
const lugarTorneo = ref<string>();
const tipoTorneo = ref<string>("");
const esLiga = ref<boolean>(false);
const idRangoTorneo = ref<number>(1);
const esMatchedPlayTorneo = ref<boolean>(false);
const metodosPago = ref<string[]>([]);
const horaInicioTorneo = ref<string>("");
const horaFinTorneo = ref<string>("");
const fechaInicioInscripcion = ref<string>("");
const fechaInicioTorneo = ref<string>("");
const fechaFinTorneo = ref<string>("");
const fechaFinEntregaListas = ref<string>("");
const fechaFinInscripcion = ref<string>("");
const imageInput = ref<HTMLInputElement | null>(null);
const imageBase64 = ref<string | null>(null);
const byteArrayBases = ref<Uint8Array | null>(null);
const isGenerating = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const listasPorJugador = ref<number>();
const form = ref();

watch(
  () => props.torneo,
  (newTorneo) => {
    if (newTorneo) {
      nombreTorneo.value = newTorneo.nombreTorneo || "";
      limiteParticipantes.value = newTorneo.limiteParticipantes;
      descripcionTorneo.value = newTorneo.descripcionTorneo || "";
      lugarTorneo.value = newTorneo.lugarTorneo || "";
      precioTorneo.value = newTorneo.precioTorneo;
      numeroPartidas.value = newTorneo.numeroPartidas;
      puntosTorneo.value = newTorneo.puntosTorneo;
      metodosPago.value = newTorneo.metodosPago;
      horaInicioTorneo.value =
        newTorneo.horaInicioTorneo.substring(
          0,
          newTorneo.horaInicioTorneo.lastIndexOf(":")
        ) || "00:00";
      horaFinTorneo.value =
        newTorneo.horaFinTorneo.substring(
          0,
          newTorneo.horaFinTorneo.lastIndexOf(":")
        ) || "00:00";
      fechaInicioTorneo.value = newTorneo.fechaInicioTorneo;
      fechaFinTorneo.value = newTorneo.fechaFinTorneo;
      fechaFinEntregaListas.value = newTorneo.fechaEntregaListas;
      fechaFinInscripcion.value = newTorneo.fechaFinInscripcion;
      fechaInicioInscripcion.value = newTorneo.inicioInscripciones;
      listasPorJugador.value = newTorneo.listasPorJugador;
      tipoTorneo.value = newTorneo.tipoTorneo;
    }
  },
  { immediate: true }
);

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const errorFechaTorneo = ref<string>("");
const errorFechaInscripcion = ref<string>("");
const errorFechaCierreInscripcion = ref<string>("");
const errorFechaListas = ref<string>("");

watch([fechaInicioTorneo, fechaFinTorneo], ([inicio, fin]) => {
  errorFechaTorneo.value =
    inicio && fin && new Date(inicio) > new Date(fin)
      ? "La fecha de comienzo del torneo debe ser anterior a la fecha de finalización."
      : "";
});

watch([fechaInicioInscripcion, fechaFinInscripcion], ([inicio, fin]) => {
  errorFechaInscripcion.value =
    inicio && fin && new Date(inicio) > new Date(fin)
      ? "La fecha de apertura de inscripciones debe ser anterior a la de cierre."
      : "";
});

watch(
  [fechaFinInscripcion, fechaInicioTorneo],
  ([finInscrip, inicioTorneo]) => {
    errorFechaCierreInscripcion.value =
      finInscrip &&
      inicioTorneo &&
      new Date(finInscrip) > new Date(inicioTorneo)
        ? "El cierre de inscripciones debe ser anterior al inicio del torneo."
        : "";
  }
);

watch(
  [fechaFinEntregaListas, fechaInicioTorneo],
  ([finListas, inicioTorneo]) => {
    errorFechaListas.value =
      finListas && inicioTorneo && new Date(finListas) > new Date(inicioTorneo)
        ? "La fecha de cierre de envío de listas debe ser anterior al inicio del torneo."
        : "";
  }
);

const convertirFecha = (dateString: string) => {
  const dateParts = dateString.split("/");

  if (dateParts.length !== 3) {
    throw new Error("El formato de la fecha debe ser dd-mm-aaaa");
  }

  const day = dateParts[0];
  const month = dateParts[1];
  const year = dateParts[2];

  return `${year}-${month}-${day}`;
};

const onImageSelected = async (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const maxWidth = 500; // Cambia esto al ancho máximo deseado
        const maxHeight = 500; // Cambia esto a la altura máxima deseada
        let width = img.width;
        let height = img.height;

        if (width > maxWidth || height > maxHeight) {
          if (width > height) {
            height *= maxWidth / width;
            width = maxWidth;
          } else {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height);
          // Convertir el canvas a base64
          imageBase64.value = canvas.toDataURL("image/jpeg", 0.7); // Ajusta la calidad de 0 a 1
        }
      };
      img.src = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }
};

const onFileChange = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];

  if (file) {
    const reader = new FileReader();

    reader.onload = async (event) => {
      if (event.target?.result) {
        const arrayBuffer = event.target.result as ArrayBuffer;
        byteArrayBases.value = new Uint8Array(arrayBuffer);
      }
    };

    reader.readAsArrayBuffer(file);
  }
};

const confirmarConfiguracion = async () => {
  const isFormValid = await form.value.validate();
  if (!isFormValid) return;

  if (!isValid.value) {
    return;
  }

  const basesTorneoBase64 = byteArrayBases.value
    ? btoa(
        new Uint8Array(byteArrayBases.value).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      )
    : null;

  const torneoTypeSelected = computed<TorneoType>(() => {
    return torneoType.includes(tipoTorneo.value as TorneoType)
      ? (tipoTorneo.value as TorneoType)
      : "Individual"; // Valor por defecto
  });

  const nuevoTorneo: ModificarTorneoDTO = {
    nombreTorneo: nombreTorneo.value,
    limiteParticipantes: limiteParticipantes.value,
    fechaInicioTorneo: fechaInicioTorneo.value,
    fechaFinTorneo: fechaFinTorneo.value,
    precioTorneo: precioTorneo.value,
    numeroPartidas: numeroPartidas.value,
    puntosTorneo: puntosTorneo.value,
    estadoTorneo: estadoTorneo.value,
    lugarTorneo: lugarTorneo.value,
    tipoTorneo: torneoTypeSelected.value,
    esLiga: esLiga.value,
    idRangoTorneo: idRangoTorneo.value,
    esMatchedPlayTorneo: esMatchedPlayTorneo.value,
    fechaEntregaListas: fechaFinEntregaListas.value,
    fechaFinInscripcion: fechaFinInscripcion.value,
    horaInicioTorneo: horaInicioTorneo.value + ":00",
    horaFinTorneo: horaFinTorneo.value + ":00",
    cartelTorneo: imageBase64.value ?? undefined,
    basesTorneo: basesTorneoBase64 ?? undefined,
    descripcionTorneo: descripcionTorneo.value,
    idTorneo: props.torneo?.idTorneo,
    inicioInscripciones: fechaInicioInscripcion.value,
    listasPorJugador: listasPorJugador.value ?? 1,
  };
  try {
    isGenerating.value = true;
    await modificarTorneo(nuevoTorneo);

    showSuccessModal.value = true;
  } catch (error) {
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }

  emit("confirm");
  closeModal();
};

const today = new Date().toISOString().split("T")[0];

const validateRequired = (v: string) => !!v || "Campo obligatorio";
const validateNotPast = (v: string) =>
  v >= today || "No puede ser una fecha pasada";
const validateFechaInicioFinTorneo = (v: string) =>
  !fechaFinTorneo.value ||
  v <= fechaFinTorneo.value ||
  "Debe ser anterior o igual a la fecha de fin";
const validateFechaFinInicioTorneo = (v: string) =>
  !fechaInicioTorneo.value ||
  v >= fechaInicioTorneo.value ||
  "Debe ser posterior o igual a la fecha de inicio";

const validateFinDespuesDeInicio =
  (inicio: string, mensaje = "Debe ser posterior o igual al inicio") =>
  (v: string) =>
    !inicio || !v || v >= inicio || mensaje;

const validateAntesDe = (fechaLimite: string, mensaje: string) => (v: string) =>
  !fechaLimite || !v || v <= fechaLimite || mensaje;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_l_popup = _resolveComponent("l-popup")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Modificar torneo")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_key: "form",
                  ref: form,
                  modelValue: isValid.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((isValid).value = $event)),
                  "lazy-validation": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: nombreTorneo.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombreTorneo).value = $event)),
                      label: "Nombre del torneo",
                      required: "",
                      type: "text",
                      rules: [(v) => !!v || 'Campo obligatorio']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: descripcionTorneo.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((descripcionTorneo).value = $event)),
                      label: "Descripción del torneo (opcional)",
                      type: "text",
                      clearable: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: searchQuery.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                      label: "¿Dónde se celebra el torneo?",
                      placeholder: "Ej: Calle Gran Vía, Madrid",
                      onKeyup: _withKeys(searchLocation, ["enter"])
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          loading: isSearching.value,
                          color: "primary",
                          variant: "tonal",
                          onClick: searchLocation
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Buscar")
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (errorMessage.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(errorMessage.value), 1))
                      : (formattedAddress.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Dirección validada: " + _toDisplayString(formattedAddress.value), 1))
                        : _createCommentVNode("", true),
                    (selectedLocation.value)
                      ? (_openBlock(), _createBlock(_unref(LMap), {
                          key: 2,
                          zoom: zoom.value,
                          center: [selectedLocation.value.lat, selectedLocation.value.lng],
                          options: {
              dragging: false,
              zoomControl: false,
              scrollWheelZoom: false,
            },
                          style: {"height":"300px","width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(LTileLayer), { url: tileLayerUrl.value }, null, 8, ["url"]),
                            _createVNode(_unref(LMarker), { "lat-lng": selectedLocation.value }, {
                              default: _withCtx(() => [
                                _createVNode(_component_l_popup, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(formattedAddress.value), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["lat-lng"])
                          ]),
                          _: 1
                        }, 8, ["zoom", "center"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_text_field, {
                      modelValue: limiteParticipantes.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((limiteParticipantes).value = $event)),
                      label: "Limite de jugadores",
                      required: "",
                      type: "number",
                      rules: [(v) => !isNaN(v) || 'Debe ser un número',
               (v) => v > 0 || 'Debe ser mayor que 0']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: puntosTorneo.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((puntosTorneo).value = $event)),
                      label: "¿A cuantos puntos es el torneo?",
                      required: "",
                      type: "number",
                      rules: [(v) => !isNaN(v) || 'Debe ser un número', 
                (v) => v > 0 || 'Debe ser mayor que 0']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: listasPorJugador.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listasPorJugador).value = $event)),
                      label: "¿Cúantas listas necesitará un jugador?",
                      required: "",
                      type: "number",
                      rules: [(v) => !isNaN(v) || 'Debe ser un número',
               (v) => v > 0 || 'Debe ser mayor que 0']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: numeroPartidas.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((numeroPartidas).value = $event)),
                      label: "¿Cuantas rondas tiene el torneo?",
                      required: "",
                      type: "number",
                      rules: [(v) => !isNaN(v) || 'Debe ser un número', 
                (v) => v > 0 || 'Debe ser mayor que 0']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_select, {
                      modelValue: tipoTorneo.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((tipoTorneo).value = $event)),
                      label: "¿De qué tipo es el torneo?",
                      required: "",
                      items: ['Individual', 'Parejas', 'Equipos de 4', 'Equipos de 6'],
                      rules: [(v) => !!v || 'Campo obligatorio']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: fechaInicioTorneo.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((fechaInicioTorneo).value = $event)),
                      label: "Inicio del torneo",
                      type: "date",
                      rules: [
              validateRequired,
              validateNotPast,
              validateFechaInicioFinTorneo,
            ],
                      required: "",
                      onDateChanged: handleDateChangeInicio,
                      "error-messages": errorFechaTorneo.value
                    }, null, 8, ["modelValue", "rules", "error-messages"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: fechaFinTorneo.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fechaFinTorneo).value = $event)),
                      label: "Fin del torneo",
                      type: "date",
                      rules: [validateRequired, validateFechaFinInicioTorneo],
                      required: "",
                      onDateChanged: handleDateChangeFin,
                      "error-messages": errorFechaTorneo.value
                    }, null, 8, ["modelValue", "rules", "error-messages"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: precioTorneo.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((precioTorneo).value = $event)),
                      label: "¿Cuál es el precio del torneo?",
                      required: "",
                      type: "number",
                      rules: [(v) => !isNaN(v) || 'Debe ser un número']
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: metodosPago.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((metodosPago).value = $event)),
                      label: "¿Como se puede pagar?",
                      type: "text",
                      clearable: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: fechaInicioInscripcion.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((fechaInicioInscripcion).value = $event)),
                      label: "Inicio de las inscripciones",
                      type: "date",
                      rules: [
              validateRequired,
              validateAntesDe(
                fechaFinInscripcion.value,
                'Debe ser antes de la fecha de fin de inscripción'
              ),
              validateAntesDe(
                fechaInicioTorneo.value,
                'Debe ser antes de la fecha de inicio del torneo'
              ),
            ],
                      required: "",
                      onDateChanged: handleDateChangeInicioInscripcion,
                      "error-messages": errorFechaInscripcion.value
                    }, null, 8, ["modelValue", "rules", "error-messages"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: fechaFinInscripcion.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((fechaFinInscripcion).value = $event)),
                      label: "Último día para apuntarse al torneo",
                      type: "date",
                      rules: [
              validateRequired,
              validateFinDespuesDeInicio(
                fechaInicioInscripcion.value,
                'Debe ser posterior al inicio de inscripción'
              ),
              validateAntesDe(
                fechaInicioTorneo.value,
                'Debe ser antes del inicio del torneo'
              ),
            ],
                      required: "",
                      onDateChanged: handleDateChangeInscripcion,
                      "error-messages": 
              [errorFechaInscripcion.value, errorFechaCierreInscripcion.value].filter(
                Boolean
              )
            
                    }, null, 8, ["modelValue", "rules", "error-messages"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: fechaFinEntregaListas.value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((fechaFinEntregaListas).value = $event)),
                      label: "Último día para entregar las listas",
                      type: "date",
                      rules: [
              validateRequired,
              validateAntesDe(
                fechaFinInscripcion.value,
                'Debe ser anterior al cierre de inscripciones'
              ),
              validateAntesDe(
                fechaInicioTorneo.value,
                'Debe ser antes del inicio del torneo'
              ),
            ],
                      required: "",
                      onDateChanged: handleDateChangeListas,
                      "error-messages": errorFechaListas.value
                    }, null, 8, ["modelValue", "rules", "error-messages"]),
                    _createVNode(_component_v_file_input, {
                      clearable: "",
                      label: "Bases del torneo",
                      required: "",
                      accept: "application/pdf",
                      onChange: onFileChange,
                      "show-size": ""
                    }),
                    _createVNode(_component_v_file_input, {
                      ref_key: "imageInput",
                      ref: imageInput,
                      label: "Selecciona una imagen",
                      onChange: onImageSelected,
                      accept: "image/*",
                      "show-size": ""
                    }, null, 512),
                    _createVNode(_component_v_text_field, {
                      modelValue: horaInicioTorneo.value,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((horaInicioTorneo).value = $event)),
                      label: "Hora de inicio del torneo (HH:MM)",
                      clearable: "",
                      rules: [
              (v) =>
                /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(v) ||
                'Formato debe ser HH:MM',
            ]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: horaFinTorneo.value,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((horaFinTorneo).value = $event)),
                      label: "Hora de finalización del torneo (HH:MM)",
                      clearable: "",
                      rules: [
              (v) =>
                /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(v) ||
                'Formato debe ser HH:MM',
            ]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4 ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: isGenerating.value,
                      onClick: confirmarConfiguracion,
                      color: "primary",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Modificar")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "secondary",
                      onClick: closeModal,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            }),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Torneo modificado correctamente.",
      "onUpdate:isVisible": _cache[20] || (_cache[20] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido modificar el torneo. Intentalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[21] || (_cache[21] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})